<template>
    <div :class="`msg-item-container ${isMe ? 'isMe' : ''}`">
        <div class="pic-left" v-if="!isMe">
          <img src="../../assert/baobao.png" v-if="userType == 2"/>
          <img src="../../assert/baobao.png" v-if="userType == 3"/>
        </div>
        <div class="pic-right" v-if="isMe">
          <img src="../../assert/customer.jpg" />
        </div>
        <div class="msg-item-content">
            <div :class="`${chatmessageCls ? chatmessageCls : 'chatmessage'} ${noBorderBottomRadius ? 'noBorderBottomRadius': ''}`">
				<div
					v-if="isMe && sendType !== 2"
					:class="`msg-sendType ${sendType == 1 ? 'loading' : sendType == 3 ? 'fail' : ''}`"
					:style="fontstyle"
					@click="iconClick">
				</div>
              <slot name="chatmessage"/>
			  <div class="tail"></div>
            </div>
            <slot name="otherMsg"/>
        </div>
  </div>
</template>

<script>
// import Bus from '../../store/plugins/bus.js'
export default {
  name: 'base-frame',
  data(){
    return{
      fontstyle:{},
    }
  },
  mounted(){
    Bus.$on('changefontstyle', (e) => {
      this.fontstyle = e
    })
  },
  props: {
    isMe: Boolean,
    chatmessageCls: {
      type: String,
      default: ''
    },
    sendType: {
      type: Number,
      default: 0
    },
    userType: {
      type: Number,
      default: 2
    },
    noBorderBottomRadius: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    iconClick() {
      this.$alert({
        content: '重新发送消息？',
        btnLeft: '取消',
        btnRight: '重新发送',
        btnRightStyle: 'color:#FF4400',
        btnRightClick: () => {
          this.$emit("iconClick", this.sendType)
        }
      })
    }
  }
}
</script>

<style>
  .msg-item-container {
    /* display: flex; */
    width: 100%;
    padding-top: 10px;
    clear: both;
  }

  .pic-left,
  .pic-right {
    /* flex: 0 0 44px; */
    width: 44px;
    height: 44px;
    border-radius: 50%;
    overflow: hidden;
    margin-top: 5px;
  }

  .pic-left {
    float: left;
  }

  .pic-right {
    float: right;
  }

  .pic-left img,
  .pic-right img {
    width: 100%;
    height: 100%;
  }
  .tail{
		width: 10px;
		height: 16px;
		border-radius: 0 0 0 0;
		padding: 0;
		display: inline-block;
		position: absolute;
		top: -1px;
		left: -13px;
		color: #fff;
	}
	.isMe .tail{
		top: -1px !important;
		right: -4px!important;
		left:auto
	}
	.chatmessage .tail::before{
		content: url("../../assert/img2.png");
	}
	.isMe .chatmessage .tail::before{
		content: url("../../assert/img1.png");
	}
  .msg-item-content {
    /* flex: 1; */
    box-sizing: border-box;
    padding: 5px 20px 0 64px;
    position: relative;
    max-width: 75%;
  }

  .msg-item-container.isMe .msg-item-content {
    text-align: right;
    padding: 5px 64px 0 20px;
    max-width: 100%;
  }

  .msg-item-container.isMe .chatmessage{
    background-color: #FF6434;
    color: #fff;
    border-top-right-radius: 0px;
    border-top-left-radius: 8px;
    word-break: break-all;
    border: none;
  }

  .w100 .chatmessage {
    /* width: 100%; */
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    min-width: 288px;
  }

  @media screen and (min-width: 800px){
	.chatmessage {
		 max-width:530px;
	}
}
  .chatmessage {
    padding: 10px;
    box-sizing: border-box;
    /* border-radius: 5px; */
    background-color: #fff;
    display: inline-block;
    text-align: left;
    font-size: 14px;
    position: relative;
    border-top-left-radius: 0;
    word-wrap: break-word;
     border: 1px solid #e5e5e5;
    border-radius: 8px;
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  .chatmessage img{
    max-height: 180px;
    max-width: 100%;
    border-radius: 5px;
  }

  .msg-sendType {
    position: absolute;
    left: -20px;
    width: 20px;
    height: 20px;
    top: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
  }

  .msg-sendType.loading {
    background-image: url("../../assert/sending.gif");
  }

  .msg-sendType.fail {
    background-image: url("../../assert/sendFail.png")
  }

  .noBorderBottomRadius {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }


.question-title {
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  line-height: 20px;
  padding: 5px 0;
}

.question-title .refresh {
  font-size: 12px;
  color: #83A6D0;
  float: right;
  font-weight: normal;
  cursor: pointer;
}

.question-title .refresh img {
  height: 20px;
}

.question-list {
  padding-top: 5px;
}

.question-list>li {
  color: #008AFF;
  line-height: 20px;
  font-size: 14px;
  padding: 5px 0;
  cursor: pointer;
}
.question-list>li:hover{
	text-decoration: underline;
}

</style>




// WEBPACK FOOTER //
// src/components/templates/BaseFrame.vue